import * as React from 'react';

import { translate } from '~l10n/client';
import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation } from '~shared/components/Dialog';
import { useGetWorkspaceDetail } from '~teacher/hook/workspaces';

interface RemoveMemberDialogProps {
  open: boolean;
  onClose: () => void;
  name: string;
  action: () => void;
  isDisabled: boolean;
  workspaceId: string;
  isSelf?: boolean;
}

export const RemoveMemberDialog = ({
  open,
  onClose,
  name,
  action,
  isDisabled,
  workspaceId,
  isSelf = false,
}: RemoveMemberDialogProps) => {
  const { data } = useGetWorkspaceDetail({ workspaceId });
  return (
    <DialogConfirmation
      actions={[
        <UIButton key="cancel" isDisabled={isDisabled} onClick={onClose}>
          {translate('Cancel')}
        </UIButton>,
        <UIButton
          key="primary"
          isDisabled={isDisabled}
          appearance="risky"
          onClick={action}
        >
          {translate('Remove')}
        </UIButton>,
      ]}
      open={open}
      onClose={onClose}
      id={'remove-member-dialog'}
      title={
        isSelf
          ? translate('Leave This Library?')
          : translate('Remove {0} From This Library?').format(name)
      }
    >
      <span className="text-blue-900">
        {isSelf
          ? translate(
              "You'll no longer have access to {0}, its quiz library, or its reports. Any folders or quizzes you've added will remain."
            ).format(data?.name ?? '')
          : translate(
              '"{0}" will no longer have access to "{1}" and its quiz library. Any folders or quizzes they have inside of the library will remain.'
            ).format(name, data?.name ?? '')}
      </span>
    </DialogConfirmation>
  );
};
